import { Bell } from "react-feather"
import { useSelector } from "react-redux"
import { Alert, Badge, Card, CardBody, CardHeader } from "reactstrap"

const FFAlerts = ({ }) => {
    const { dashBoardalert } = useSelector(state => state.ffdashboard)
    const getAlertColor = (status) => {
        switch (status) {
            case "ON TIME": return "success"
            case "DELAYED": return "warning"
            case "AT RISK": return "danger"
            default: return "primary"
        }
    }
   
    const totalAlerts = dashBoardalert.length
    const delayedAlerts = dashBoardalert.filter(alert => alert.status === "DELAYED")
    const atRiskAlerts = dashBoardalert.filter(alert => alert.status === "AT RISK")

    return (
        <>
            <Card className='mb-4'>
                <CardHeader>
                    <h2 className='text-xl font-bold flex items-center'>
                        <Bell className='mr-2' /> Alerts
                    </h2>
                </CardHeader>
                <CardBody>
                    {totalAlerts === 0 ? (
                        <p>No current alerts.</p>
                    ) : (
                        <>
                        {delayedAlerts.length > 0 && (
                            <>
                                <table className='table'>
                                    <tbody>
                                        {delayedAlerts.map((alert, index) => (
                                            <tr key={index}>
                                                <td style={{ padding: '0.5rem', width: '5%' }}>
                                                    <Badge color={`${getAlertColor(alert.status)}`}>{alert.status}</Badge>
                                                </td>
                                                <td style={{ padding: '0.5rem', width: '74%' }}>
                                                    <Alert variant='destructive' className='mb-0' color={`${getAlertColor(alert.status)}`}>
                                                        <div className='d-flex align-items-center alert-body'>
                                                            {alert.context}
                                                        </div>
                                                    </Alert>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>
                        )}
                        <table className='table'>
                            <tbody>
                                {atRiskAlerts.map((alert, index) => (
                                    <tr key={index}>
                                        <td style={{ padding: '0.5rem', width: '6.4%' }}>
                                            <Badge color={`${getAlertColor(alert.status)}`}>{alert.status}</Badge>
                                        </td>
                                        <td style={{ padding: '0.5rem', width: '95%' }}>
                                            <Alert variant="destructive" className="mb-0" color={`${getAlertColor(alert.status)}`}>
                                            <div className='d-flex align-items-center alert-body'>
                                                {alert.context}
                                            </div>
                                            </Alert>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </>
                    )}
                </CardBody>
            </Card>
        </>
    )
}

export default FFAlerts